import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { DraggableAttributes } from "@dnd-kit/core";
import styled from "@emotion/styled";

type DragListeners = ReturnType<typeof useSortable>["listeners"];

const Wrapper = styled.div`
  position: relative;
  height: 100%;
  width: 220px;
  flex-shrink: 0;

  ${(p) => p.theme.media.mobileDown} {
    width: 160px;
  }
`;

interface Props {
  id: string;
  onActivate?: () => void;
  children: (handleProps: {
    dragHandleRef: ReturnType<typeof useSortable>["setActivatorNodeRef"];
    dragHandleListeners: DragListeners;
    dragHandleAttributes: DraggableAttributes;
  }) => React.ReactNode;
}

export const SortableComparisonPropertySlide = ({
  id,
  onActivate,
  children,
}: Props) => {
  const {
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    listeners,
    attributes,
    isDragging,
  } = useSortable({ id });

  const wrappedListeners: DragListeners = {
    ...listeners,
    onPointerDown: (e: React.PointerEvent) => {
      onActivate?.();
      listeners?.onPointerDown?.(e);
    },
  };

  return (
    <Wrapper
      ref={setNodeRef}
      style={{
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0 : 1,
      }}
    >
      {children({
        dragHandleRef: setActivatorNodeRef,
        dragHandleListeners: wrappedListeners,
        dragHandleAttributes: attributes,
      })}
    </Wrapper>
  );
};
